// extracted by mini-css-extract-plugin
export default {"topLogoutBtn":"LogoutButton_topLogoutBtn__3S5wy"};